'use client';

import React, { ComponentType } from 'react';
import useDriftStore from '../../stores/DriftStore/useDriftStore';
import useCurrentWalletIconSrc from 'src/hooks/useCurrentWalletIconSrc';
import { useShallow } from 'zustand/react/shallow';
import Phantom from 'src/components/Icons/Phantom';
import Backpack from 'src/components/Icons/Backpack';
import Solflare from 'src/components/Icons/Solflare';
import Jupiter from 'src/components/Icons/Jupiter';
import OKX from 'src/components/Icons/OKX';
import { Delegation, Drift, IconProps } from '@velocity-exchange/icons';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

const ICON_BY_ADAPTER_NAME: Record<string, ComponentType<IconProps>> = {
	phantom: Phantom,
	backpack: Backpack,
	solflare: Solflare,
	jupiter: Jupiter,
	'okx wallet': OKX,
};

export default function TopBarWalletButtonIcon() {
	const [connected, adapterName] = useDriftStore(
		useShallow((s) => [
			!!s.wallet.current?.adapter?.connected,
			s.wallet.current?.adapter?.name?.toLowerCase(),
		])
	);
	const currentAccount = useDriftAccountStore(
		(s) => s.accounts[s.currentUserKey ?? '']
	);

	const currentWalletIconSrc = useCurrentWalletIconSrc();

	if (!connected) {
		return null;
	}

	if (currentAccount?.isDelegatedTo) {
		return <Delegation />;
	}

	const content = (() => {
		if (adapterName && adapterName in ICON_BY_ADAPTER_NAME) {
			const Icon =
				ICON_BY_ADAPTER_NAME[adapterName as keyof typeof ICON_BY_ADAPTER_NAME];

			return <Icon className="text-text-default" size={16} />;
		}

		if (currentWalletIconSrc) {
			return <img src={currentWalletIconSrc} className="size-full" />;
		}

		// Default to Drift logo if no icon is found (e.g. when using `?authority`).
		return (
			<Drift
				className="relative -top-0.5 -left-0.5 text-text-default"
				size={20}
			/>
		);
	})();

	return <div className="size-4">{content}</div>;
}
